import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Stepper from '@material-ui/core/Stepper'
import Step from '@material-ui/core/Step'
import StepLabel from '@material-ui/core/StepLabel'
import AppStore from '../../store/AppStore'
import HomeAction from '../actions/HomeAction'
import DtoUser from '../dto/DtoUser'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import TutorialStep from './TutorialStep'
import Step1 from '../../../public/pictures/tutorial/Step1.jpg'
import Step2 from '../../../public/pictures/tutorial/Step2.jpg'
import Step3 from '../../../public/pictures/tutorial/Step3.jpg'
import Step4 from '../../../public/pictures/tutorial/Step4.jpg'
import Step5 from '../../../public/pictures/tutorial/Step5.jpg'
import Step6 from '../../../public/pictures/tutorial/Step6.png'
import Step6bg from '../../../public/pictures/tutorial/Step6-bg.jpg'
import Fab from '@material-ui/core/Fab'
import CloseIcon from '@material-ui/icons/Close'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
import DoneIcon from '@material-ui/icons/Done'

const $ = window.$

const initialState = {
	finished: false,
	stepIndex: 0,
	nbSteps: 5,
	stopDisplaying: false
}

class Tutorial extends Component {
	constructor(props) {
		super(props)
		this.state = initialState
	}

	handleNext = () => {
		const { nbSteps, finished, stepIndex } = this.state
		if (!finished) {
			this.setState({
				stepIndex: stepIndex + 1,
				finished: stepIndex + 1 >= nbSteps
			})
		} else {
			this.close()
			const { firstConnection, login } = this.props.user
			if (firstConnection && this.state.stopDisplaying) {
				AppStore.dispatch(HomeAction.updateFirstConnection(login))
				this.createModal(true)
			}
		}
	}

	handleStopDisplaying = () => {
		this.setState({ stopDisplaying: !this.state.stopDisplaying })
	}

	close = () => {
		$('#tutorial').modal('close')
	}

	handlePrev = () => {
		const { nbSteps, stepIndex } = this.state
		if (stepIndex > 0) {
			this.setState({
				stepIndex: stepIndex - 1,
				finished: stepIndex - 1 >= nbSteps
			})
		}
	}

	getStepContent(stepIndex) {
		switch (stepIndex) {
			case 0:
				return (<TutorialStep img={ Step1 } background='#00204c'/>)
			case 1:
				return (<TutorialStep img={ Step2 } background='#88999A'/>)
			case 2:
				return (<TutorialStep img={ Step3 } background='#0EC7D2'/>)
			case 3:
				return (<TutorialStep img={ Step4 } background='#395080'/>)
			case 4:
				return (<TutorialStep img={ Step5 } background='#548A4D'/>)
			default:
				return (<TutorialStep img={ Step6 } background={ `url(${ Step6bg })` }/>)
		}
	}

	createModal = (dismissible) => {
		$('#tutorial').modal({
			dismissible,
			complete: () => this.setState(initialState)
		})
	}

	componentDidMount() {
		this.createModal(!this.props.user.firstConnection)
	}

	componentDidUpdate(prevProps) {
		if (prevProps.open !== this.props.open && this.props.open === true) {
			$('#tutorial').modal('open')
		}
	}

	render() {
		const { finished, stepIndex } = this.state
		return (
			<div id='tutorial' className='modal fullscreen-modal modal-fixed-footer'>
				<div className='modal-content'>
					<div className='modal-header'>
						<Stepper activeStep={ stepIndex }>
							<Step><StepLabel>{ i18n.aquaDB }</StepLabel></Step>
							<Step><StepLabel>{ i18n.themes }</StepLabel></Step>
							<Step><StepLabel>{ i18n.research }</StepLabel></Step>
							<Step><StepLabel>{ i18n.selection }</StepLabel></Step>
							<Step><StepLabel>{ i18n.download }</StepLabel></Step>
						</Stepper>
					</div>
					<div className='modal-c'>{ this.getStepContent(stepIndex) }</div>
				</div>
				<div className='modal-footer valign-wrapper row' style={ { marginBottom: '4px' } }>
					{
						!this.props.user.firstConnection && (
							<div className='col s4'>
								<Fab children={ <CloseIcon/> } size='small' color='primary' onClick={ this.close } className='left'/>
							</div>
						)
					}
					<div className='col s8'>
						<div className='right'>
							<Fab children={ <ArrowBackIcon/> } size='small' disabled={ stepIndex === 0 } color='primary' onClick={ this.handlePrev }/>
							<span style={ { width: '24px', display: 'inline-block' } }/>
							<Fab children={ finished ? <DoneIcon/> : <ArrowForwardIcon/> } size='small' color='primary' primary={ true } onClick={ this.handleNext }/>
						</div>
						{
							this.props.user.firstConnection && (
								<div className='margin-top-5 right'>
									<input checked={ this.state.stopDisplaying } className='filled-in' onChange={ this.handleStopDisplaying } type='checkbox' id='stop'/>
									<label htmlFor='stop'>{ i18n.stopDisplaying }</label>
								</div>
							)
						}
					</div>
				</div>
			</div>
		)
	}
}

Tutorial.propTypes = {
	open: PropTypes.bool,
	user: PropTypes.instanceOf(DtoUser)
}

const mapStateToProps = store => {
	return {
		user: store.HomeReducer.user
	}
}

export default connect(mapStateToProps)(Tutorial)



// WEBPACK FOOTER //
// ./src/home/components/Tutorial.js